// extracted by mini-css-extract-plugin
export default {"wrapper_swiper":"carusel_wrapper_swiper__R1uk8"};